import { SVGProps, Ref, forwardRef } from 'react';

export const FacebookSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.848 14.945a7.001 7.001 0 1 0-2.54-.154v-4.655H4.865v-2.14h1.445v-.924c0-2.383 1.078-3.486 3.416-3.486.442 0 1.207.087 1.52.174V5.7a9 9 0 0 0-.809-.025c-1.148 0-1.59.434-1.59 1.565v.756h2.287l-.392 2.14H8.848z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FacebookSolidSize16Glyph.displayName = 'FacebookSolidSize16Glyph';
